import React from 'react';
import SurveyPage from '../components/SurveyPage';
import SurveyTitleArea from '../components/SurveyTitleArea';
import SurveySection from '../components/SurveySection';
import SurveyElement from '../components/SurveyElement';
import SurveyContentContainer from '../components/SurveyContentContainer';
import {
  CommonResponses, ElementType,
  NumberFormat,
  SelectCombos, SelectCombosPABS,
  PabsMoreInfoPanels,
} from '../Enums/constants';
import SurveyConditionalSegment from '../components/SurveyConditionalSegment';


export const PabsTransactionsTab = () => {
  return (
    <SurveyPage>
      <SurveyTitleArea pageName="Transactions" />
      <SurveyContentContainer>
        <SurveySection
          id="1"
          labelText="Pension Payments"
          helpText={PabsMoreInfoPanels.PensionPayments}
        >
          <SurveyElement
            questionNumber="17"
            labelText="Do you administer annuity pensions?"
            name="AdministerAnnuityPensionsYN"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
          />
          <SurveyConditionalSegment
            showIf={{
              AdministerAnnuityPensionsYN: { not: CommonResponses.NO }
            }}
          >
            <SurveyElement
              questionNumber="18"
              labelText="Were any of your pension payrolls late vis-a-vis your normal payment cycle?"
              name="SACRSLatePayroll"
              inputType={ElementType.SELECT}
              options={SelectCombos.YES_NO}
            />
            <SurveyConditionalSegment
              showIf={{
                SACRSLatePayroll: { not: CommonResponses.NO }
              }}
            >
              <SurveyElement
                questionNumber="18.a"
                labelText="How many payrolls were late?"
                name="SACRSLatePayrollHowMany"
                inputType={ElementType.NUMBER}
                format={NumberFormat.INTEGER}
                placeholder="#"
                subQuestion
                allowNA
              />
              <SurveyElement
                questionNumber="18.b"
                labelText="On average, how many days late were they?"
                name="SACRSLatePayrollDays"
                inputType={ElementType.NUMBER}
                format={NumberFormat.INTEGER}
                placeholder="# days"
                subQuestion
                allowNA
              />
            </SurveyConditionalSegment>
            <SurveyElement
              questionNumber="19"
              labelText="What percent of pensioners are paid by check?"
              note="as opposed to Electronic Funds Transfer ('EFT')"
              name="CheckPaymentsPct"
              inputType={ElementType.NUMBER}
              format={NumberFormat.PERCENTAGE}
              placeholder="%"
            />
          </SurveyConditionalSegment>
        </SurveySection>
        <SurveySection
          id="2"
          labelText="Pension Inceptions and Written Pension Estimates"
          helpText={PabsMoreInfoPanels.PensionInceptions}
        >
          <SurveyElement
            questionNumber="20"
            labelText="How many changes in gross amount of annuity pensions paid occurred as a result of changes in an individual annuitant's personal circumstances? "
            note="For example:  <ul> <li>When the spouse of an annuitant dies 'last survivor' options result in decreases, and 'pop-up' or 'reversion' options result in increases. [Exclude annuitant deaths that result in new pensions paid to spouses.]</li> <li>When an annuitant or their beneficiary becomes eligible for social security, it often results in a reduction of the gross pension paid.</li> <li>Redesign of the payment option, appeal decisions, high low options shifting to low, etc.</li> </ul>"
            name="ChangedPersonalCircumstances"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="#"
            allowNA
            allowUnknown
          />
          <SurveyElement
            questionNumber="21"
            labelText="What percent of annuity inceptions for:"
            inputType=""
            name=""
          />
          <SurveyElement
            questionNumber="21.a"
            labelText="Retiring active members are paid without an interruption of cash flow greater than 1 month between the final pay check and the first pension check?"
            name="Q_110"
            inputType={ElementType.NUMBER}
            format={NumberFormat.PERCENTAGE}
            placeholder="%"
            subQuestion
            allowUnknown
          />
          <SurveyElement
            questionNumber="21.b"
            labelText="Survivors are paid without an interruption of cash flow between the pensioner's final pension check and the survivor's first pension check?"
            name="Q_97bReverse"
            inputType={ElementType.NUMBER}
            format={NumberFormat.PERCENTAGE}
            placeholder="%"
            subQuestion
            allowUnknown
          />
          <SurveyElement
            questionNumber="22"
            labelText="Will you initiate a service retirement pension based on existing data or estimates, recognizing that you will have to finalize the payments later after you get final data?"
            name="Q_111"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
          />
          <SurveyConditionalSegment
            showIf={{
              Q_111: { not: CommonResponses.NO }
            }}
          >
            <SurveyElement
              questionNumber="22.a"
              labelText="What proportion of your service retirement inceptions to retiring active members was based on existing data or estimates?"
              name="Q_111a"
              inputType={ElementType.NUMBER}
              format={NumberFormat.PERCENTAGE}
              placeholder="%"
              subQuestion
              allowUnknown
            />
            <SurveyElement
              questionNumber="22.b"
              labelText="On average, how many months did it take to finalize service retirement inceptions based on estimates?"
              name="Q_111c"
              inputType={ElementType.NUMBER}
              format={NumberFormat.DECIMAL1}
              placeholder="# months"
              subQuestion
            />
          </SurveyConditionalSegment>
          <SurveyElement
            questionNumber="23"
            labelText="Do you require birth certificates and/or marriage certificates before incepting a pension?"
            name="BirthMarriageCertificates"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
          />
          <SurveyElement
            questionNumber="24"
            labelText="Do you require notarization of normal or early retirement applications?"
            name="Q_160a"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_SOME}
          />
          <SurveyElement
            questionNumber="24.a"
            labelText="Describe those that require versus those do not:"
            name="Q_160aSomeDescr"
            inputType={ElementType.TEXTAREA}
            showIf={{Q_160a: [CommonResponses.SOME, CommonResponses.BLANK]}}
            subQuestion
            allowUnknown
          />
          <SurveyElement
            questionNumber="25"
            labelText="What percentage of vested inactive members that reached their normal retirement age in the year have not received any benefits yet because the member is unreachable (e.g., mail has been returned)?"
            name="InactiveMissingBenefitsPct"
            inputType={ElementType.NUMBER}
            format={NumberFormat.PERCENTAGE}
            placeholder="%"
            allowUnknown
          />
          <SurveyElement
            questionNumber="26"
            labelText="Do you offer written pension estimates to members?"
            name="Q_104YN"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
          />
          <SurveyConditionalSegment
            placeholder="#"
            showIf={{
              Q_104YN: { not: CommonResponses.NO },
            }}
          >
            <SurveyElement
              questionNumber="27"
              labelText="How many written pension estimates were sent in response to individual member requests?"
              note="Include estimates that were sent electronically. Exclude estimates that were prepared during a counseling session and not sent in advance."
              name="Q_103"
              placeholder="#"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              allowNA
              allowUnknown
            />
            <SurveyElement
              questionNumber="28"
              labelText="When a member requests multiple different estimate scenarios, do you count each scenario as an 'estimate' or do you count the 'multiple request' as a single estimate?"
              name="DefineEstimate"
              inputType={ElementType.SELECT}
              options={SelectCombosPABS.EACH_SCENARIO_SINGLE_ESTIMATE}
              saveAsKey={true}
            />
              <SurveyElement
                questionNumber="28.a"
                labelText="If you count each scenario, what is the approximate average number of scenarios per request by a member?"
                name="DefineEstimateA"
                inputType={ElementType.NUMBER}
                format={NumberFormat.INTEGER}
                placeholder="#"
                subQuestion
                allowNA
                allowUnknown
                showIf={{
                  DefineEstimate: { not: "single" }
                }}
              />
            <SurveyElement
              questionNumber="29"
              labelText="On average, how many business days does it take to provide a written pension estimate from the time of initial request from a member?"
              name="Q_105"
              inputType={ElementType.NUMBER}
              format={NumberFormat.DECIMAL1}
              placeholder="#"
              allowNA
              allowUnknown
            />
            <SurveyElement
              questionNumber="30"
              labelText="Do your written pension estimates (including cover letters, etc., sent with the estimate):"
              inputType=""
              name=""
            />
            <SurveyElement
              questionNumber="30.a"
              labelText="Clearly address if and how the pension is inflation protected (or not protected)?"
              name="Q_109a"
              inputType={ElementType.SELECT}
              options={SelectCombos.YES_NO}
              subQuestion
            />
            <SurveyElement
              questionNumber="30.b"
              labelText="If your pension is coordinated with or reduced by social security (or CPP in Canada) is the impact explained?"
              name="Q_109b"
              inputType={ElementType.SELECT}
              options={SelectCombos.YES_NO_NA}
              subQuestion
            />
            <SurveyElement
              questionNumber="30.c"
              labelText="Discuss alternative scenarios that could improve the pension such as purchasing service credit or working longer?"
              name="Q_109c"
              inputType={ElementType.SELECT}
              options={SelectCombos.YES_NO}
              subQuestion
            />
            <SurveyElement
              questionNumber="30.d"
              labelText="Model alternative retirement payment options?"
              name="Q_109d"
              inputType={ElementType.SELECT}
              options={SelectCombos.YES_NO}
              subQuestion
            />
          </SurveyConditionalSegment>
        </SurveySection>
        <SurveySection
          id="3"
          labelText="Refunds, Withdrawals and Transfers-out"
          helpText={PabsMoreInfoPanels.RefundsWidthdrawalsEtc}
        >
          <SurveyElement
            questionNumber="31"
            labelText="How many written estimates for refunds/terminations/transfer-outs did you prepare in response to member requests?"
            note="Include all estimates whether they result in a refund or not. Include estimates that were sent electronically."
            name="NumberRefundEstimates"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="#"
            allowNA
            allowUnknown
          />
          <SurveyElement
            questionNumber="32"
            labelText="How long does it take on average, in business days, for you to complete an individual transfer-out to a member's new pension plan, including delays caused by external parties, beginning from the time of initial request by the member?"
            name="FromInitialRequest"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="# business days"
            allowNA
            allowUnknown
          />
        </SurveySection>
        <SurveySection
          id="4"
          labelText="Purchases and Transfers-in"
          helpText={PabsMoreInfoPanels.PurchasesTransfersIn}
        >
          <SurveyElement
            questionNumber="33"
            labelText="Number of actual:"
            inputType=""
            name=""
          />
          <SurveyElement
            questionNumber="33.a"
            labelText="Prior service credit purchases?"
            note="e.g., for prior refunded service, military service, etc."
            name="NumberServicePurchases"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="# or n/a"
            allowNA
            subQuestion
          />
          <SurveyElement
            questionNumber="33.b"
            labelText="In-service credit purchases?"
            note="e.g., maternity, parental, sabbatical, educational, illness leaves."
            name="InServicePurchasesOthers"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="#, unknown or n/a"
            allowNA
            allowUnknown
            subQuestion
          />
          <SurveyElement
            questionNumber="33.c"
            labelText="Upgrades or 'Top-ups' where members can improve their pensionable salary (but not service credit)?"
            name="TopUpsOfSalary"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="# or n/a"
            allowNA
            subQuestion
          />
          <SurveyElement
            questionNumber="33.d"
            labelText="Upgrades where members can pay to upgrade from an older retirement formula to a new retirement formula?"
            name="Q_204bActual"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="# or n/a"
            allowNA
            subQuestion
          />
          <SurveyElement
            questionNumber="33.e"
            labelText="Individual transfers-in from the member's previous pension plan?"
            note="For example, many systems have reciprocal agreements with 'sister' plans that permit members to transfer-in credit from their previous employer's pension plan to their new plan and vice versa. Do not include collective transfers-in."
            name="Q_204cActual"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="#, unknown or n/a"
            allowNA
            allowUnknown
            subQuestion
          />
          <SurveyElement
            questionNumber="34"
            labelText="How many written purchase, upgrade, or transfer-in estimates did you prepare in response to member requests?"
            note="Include all estimates whether these result in a purchase or not. Include estimates that were sent electronically."
            name="NumberPurchaseEstimates"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="#"
            allowNA
          />
          <SurveyElement
            questionNumber="35"
            labelText="On average, how many business days does it take from the date of first request to provide a written service credit purchase cost?"
            name="Q_205"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="#  business days"
            allowNA
            allowUnknown
          />
          <SurveyElement
            questionNumber="36"
            labelText="How long does it take on average, in months, for you to do individual transfers-in?"
            note="Include any delays caused by external parties."
            name="Q_225c"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="#  months"
            allowNA
            allowUnknown
          />
        </SurveySection>
        <SurveySection
          id="5"
          labelText="Disability"
          helpText={PabsMoreInfoPanels.Disability}
        >
          <SurveyElement
            questionNumber="37"
            labelText="Do you administer:"
            inputType=""
            name=""
          />
          <SurveyElement
            questionNumber="37.a"
            labelText="Long-term disability/ disability pensions?"
            name="Q_297a"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            subQuestion
          />
          <SurveyElement
            questionNumber="37.b"
            labelText="Short-term disability?"
            name="Q_297b"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            subQuestion
          />
          <SurveyConditionalSegment
            dependentQuestion={["Q_297a", "Q_297b"]}
            desiredValue={[CommonResponses.BLANK, CommonResponses.YES]}
          >
            <SurveyElement
              questionNumber="38"
              labelText="Number of:"
              inputType=""
              name=""
            />
            <SurveyElement
              questionNumber="38.a"
              labelText="Applications for disability pensions/ long-term disability?"
              name="Q_206b"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder="#"
              subQuestion
              allowNA
            />
            <SurveyElement
              questionNumber="38.b"
              labelText="Members receiving long-term disability or a disability pension?"
              name="LTDRecipients"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder="#"
              subQuestion
              allowNA
            />
            <SurveyElement
              questionNumber="38.c"
              labelText="Applications for short-term disability?"
              name="ApplicationsForShortTermDisability"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder="#"
              subQuestion
              allowNA
            />
            <SurveyElement
              questionNumber="38.d"
              labelText="Members receiving short-term disability?"
              name="STDRecipients"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder="#"
              subQuestion
              allowNA
            />
            <SurveyElement
              questionNumber="38.e"
              labelText="Independent medical examinations for disability application assessment or reassessment paid for by you, if any?"
              name="MedicalExaminations"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder="#"
              subQuestion
              allowNA
            />
            <SurveyElement
              questionNumber="38.f"
              labelText="New members that you reviewed the health status of?"
              name="NumberHealthReviews"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder="#"
              subQuestion
              allowNA
            />
            <SurveyElement
              questionNumber="38.g"
              labelText="Formal appeals of disability decisions?"
              name="Q_208b"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder="#"
              subQuestion
              allowNA
            />
            <SurveyElement
              questionNumber="38.h"
              labelText="Recertifications of disabled members? [For example, Arizona SRS requires an annual opinion from a physician to continue on disability.]"
              name="NumberRecertifications"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder="#"
              subQuestion
              allowNA
            />
            <SurveyElement
              questionNumber="39"
              labelText="Do you cover non-occupational disability? [Some systems only cover disabilities that happen at work.]"
              name="Q_302"
              inputType={ElementType.SELECT}
              options={SelectCombos.YES_NO}
            />
            <SurveyConditionalSegment
              showIf={{
                Q_302: { not: CommonResponses.NO },
              }}
            >
              <SurveyElement
                questionNumber="39.a"
                labelText="Does either the amount paid or the taxation of the disability benefit vary depending on whether the disability is occupational versus non-occupational?"
                name="Q_303"
                inputType={ElementType.SELECT}
                options={SelectCombos.YES_NO}
                subQuestion
              />
              <SurveyConditionalSegment
                showIf={{
                  Q_303: { not: CommonResponses.NO },
                }}
              >
                <SurveyElement
                  questionNumber="39.b"
                  labelText="If yes to a, number of occupational disability applications?"
                  name="Q_303a"
                  inputType={ElementType.NUMBER}
                  format={NumberFormat.INTEGER}
                  placeholder="#"
                  subQuestion
                />
              </SurveyConditionalSegment>
            </SurveyConditionalSegment>
            <SurveyElement
              questionNumber="40"
              labelText="How many months, on average, does it take to return a decision on a disability application from:"
              inputType=""
              name=""
            />
            <SurveyElement
              questionNumber="40.a"
              labelText="Date of initial request from a member?"
              name="Q_210"
              inputType={ElementType.NUMBER}
              format={NumberFormat.DECIMAL1}
              placeholder="# months"
              subQuestion
              allowNA
              allowUnknown
            />
            <SurveyElement
              questionNumber="40.b"
              labelText="Date of receipt of all necessary documentation to complete an application?"
              name="CompletedDisabilityAppTime"
              inputType={ElementType.NUMBER}
              format={NumberFormat.DECIMAL1}
              placeholder="# months"
              subQuestion
              allowNA
              allowUnknown
            />
          </SurveyConditionalSegment>
        </SurveySection>
      </SurveyContentContainer>
    </SurveyPage>
  );
};